module.exports = __webpack_public_path__ + "img/ProductCertification.482af29f.png";